<template>
  <div class="complementInfo" >
    <div class="login-center" :style="bg1">
      <div class="login-main w1200">
        <div class ="form-main">
          <div class="login-top">
            <img :src="assoInfo.logo" alt="">
            <p class="top-title">{{assoInfo.name}}</p>
          </div>
          <div class="form-content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="驳回原因" prop="desc">
                <el-input type="textarea" v-model="ruleForm.desc" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="会员名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="idNo">
                <el-input v-model="ruleForm.idNo"></el-input>
              </el-form-item>
               <el-form-item label="会员类别" prop="memberType">
                <el-input v-model="ruleForm.memberType" :disabled="true"></el-input>
              </el-form-item>
               <el-form-item label="会员类型" prop="typeName">
                <el-input v-model="ruleForm.typeName" :disabled="true"></el-input>
              </el-form-item>
              <el-divider><span>资料信息</span></el-divider>
              <el-form-item :label='item.dataName' :prop="item.must === 1?'must':'notmust'" v-for="(item,index) in UploadArr" :key="index">
                <div style="border:1px solid red;width:128px;height:128px;position: relative;border: 1px dashed #d9d9d9;border-radius: 6px;" v-loading="item.uploadLoading" element-loading-text="加载中"  >
                  <i class="pdelete el-icon-delete" v-if="item.imgUrl" @click="removeImg(index)"></i>
                  <el-upload
                    class="avatar-uploader"
                    action="http://mechanism.daoba.com/manager/fileUpload"
                    :show-file-list="false"
                    :on-success="(value)=> handleAvatarSuccess(index, value)"
                    :before-upload="()=> uploadBefore(index)"
                    :on-error="()=> uploadError(index)"
                    >
                  <img v-if="item.imgUrl" :src="item.imgUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <p style="line-height:24px;color:#F56C6C" v-if="item.must ==1 && item.msg !=''">{{item.msg}}</p>
                </div>
              </el-form-item>
              <div class="reset-style">
                  <el-button type="primary" @click="submitForm('ruleForm')">提交审核</el-button>
              </div>

            </el-form>

          </div>
        </div>
      </div>
    </div>
    <!-- <CopyRight></CopyRight> -->
  </div>
</template>

<script>
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import { queryBackData, reloadVerifyData } from '@/api/association'
export default {
  name: 'ComplementInfo',
  components: {
    HeaderNav,
    CopyRight
  },
  data () {
    const idCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'))
      } else {
        var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        // const reg = /^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$/
        if (regIdCard.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证号'))
        }
      }
    }
    return {
      ruleForm: {
        name: '',
        delivery: false,
        desc: '',
        idNo: '',
        memberType: null,
        typeName: ''
      },
      backData: undefined,
      UploadArr: [],
      rules: {
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, message: '长度最少在 3 个字符', trigger: 'blur' }
        ],
        idNo: [
          { required: true, validator: idCode, trigger: 'blur' }
        ],
        memberType: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        typeName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ]

      },
      step: '1',
      stepTitle: '输入账户信息',
      titleMsg: '登录',
      checked: true,
      radio: '1',
      num1: 0,

      fileList: [],
      bg1: {
        backgroundImage: 'url(/static/images/login-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0px 0px',
        backgroundSize: '100% 100%'
      },
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      assoInfo: JSON.parse(localStorage.getItem('assoInfo')),
      isActive: '0'
    }
  },
  methods: {
    onSubmit () {
      console.log('submit!')
    },
    queryBackData () {
      queryBackData(this.assoUserInfo.memberId).then(res => {
        if (res.data.status === 0) {
          this.backData = res.data.data
          this.ruleForm.desc = this.backData.reason
          this.ruleForm.name = this.backData.memberName
          this.ruleForm.idNo = this.backData.idNo
          this.ruleForm.memberType = this.backData.memberType === 1 ? '团体会员' : '个人会员'
          this.ruleForm.typeName = this.backData.typeName
          res.data.data.verifyDatas.forEach(item => {
            this.UploadArr.push({ id: item.id, dataId: item.dataId, verifyDataId: item.verifyDataId, dataName: item.dataName, must: item.must, imgUrl: '', uploadLoading: false, msg: '' })
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    removeImg (index) {
      this.UploadArr[index].imgUrl = ''
    },
    uploadBefore (index) {
      this.UploadArr[index].uploadLoading = true
    },
    uploadError (index) {
      this.UploadArr[index].uploadLoading = false
      this.$message.error('上传失败，请重新上传')
    },
    handleAvatarSuccess (index, file) {
      // debugger
      console.log(index, file)
      this.UploadArr[index].uploadLoading = false
      this.UploadArr[index].msg = ''
      this.UploadArr[index].imgUrl = file.qiniuUrl
    },
    submitForm (formName) {
      var validResult = true
      this.UploadArr.forEach(item => {
        if (item.must === 1 && item.imgUrl === '') {
          item.msg = '请选择图片'
          validResult = false
        }
      })
      if (validResult) {
        this.memberApply()
      }
    },
    memberApply () {
      let verifyDatas = []
      this.UploadArr.forEach(item => {
        let itemData = {
          dataId: item.dataId,
          path: item.imgUrl,
          verifyDataId: item.verifyDataId
        }
        verifyDatas.push(itemData)
      })
      let subParameter = {
        assoId: localStorage.getItem('assoId'),
        idNo: this.ruleForm.idNo,
        memerName: this.ruleForm.name,
        memberId: this.assoUserInfo.memberId,
        verifyDatas: verifyDatas
      }
      // this.innerDrawer = true
      this.payLoading = true
      reloadVerifyData(subParameter).then(res => {
        this.payLoading = false
        if (res.data.status === 0) {
          this.$message.success(res.data.msg)
          setTimeout(() => {
            window.open('/#/PersonInfo/', '_memberCenter')
          }, 1000)

          // this.$router.push({
          //   name: `Login`
          // })
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((res) => {
        this.payLoading = false
        // hideLoading()
        this.$message.warning('网络错误')
      })
    }

  },
  mounted () {

    // changeStep (stepNum){
    //   debugger
    //   this.step = stepNum
    // }
  },
  created () {
    this.queryBackData()
    // this.bg1.height = this.getHeight() + 'px'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-layout {
    width: 100%;
    height:100%;
  }
  .login-center {
    width: 100%;
    height: 100vh;
    padding:50px 0px;
    box-sizing: border-box;
    /* background-color: #0a4181; */
  }
  .form-content{
    margin-top: 50px;
    width: 500px;
    padding: 20px 50px;
    margin: 50px auto;
    background: rgb(45,71,151);
    /* opacity: 0.5; */
    border-radius: 10px;
  }
  .step-title{
    color: #fff;
    text-align: center;
    padding: 20px 0px;
  }
  .form-main{
    width: 880px;
    margin: 0px auto 0px auto;
  }
  .login-top{
    text-align: center;
  }
  .reset-style {
    margin-left: 0px;
    text-align: center
  }
  .login-top img{
    display: inline-block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
  }
  .login-top .top-title{
    font-size: 40px;
    color:#fff;
    margin-top:10px;
  }
  .complementInfo  /deep/ .el-form-item__label{
    color: #fff;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .a4Option .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }
  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
  .pdelete {
    position: absolute;
    width:24px;
    height: 24px;
    left: 50%;
    top:50%;
    margin-left: -12px;
    margin-top: -12px;
    z-index: 1;
    color: #fff;
    cursor: pointer;
  }
  .el-icon-delete:before{
    font-size: 24px;
  }
.fixd {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/ComplementInfo.vue